<template>
  <div>
    <b-popover target="operations" ref="operations-popover"
               :show.sync="popoverShow" custom-class="operations-popover">
      <template slot="title">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{$t('Operations')}}</span>
          <span class="close" aria-hidden="true" @click="popoverShow = !popoverShow">&times;</span>
        </div>
      </template>
      <div class="d-flex justify-content-end">
        <b-btn size="sm" title="Create new operation" variant="success" @click="createOperation">
          {{$t('buttons.common.create')}}
        </b-btn>
      </div>
      <div class="operations-groups">
        <div v-for="(dateGroup, date) in operations" :key="date">
          <div class="date-group">{{date}}</div>
          <div v-for="(operationTypeGroup, operationType) in dateGroup" :key="`${date}-${operationType}`"
               class="operations-type-group">
            {{operationType}}
            <ul class="operations-list">
              <li v-for="operation in operationTypeGroup" :key="operation.id">
                <a class="link operation-link"
                   :href="`/operation/${operation.id}`">{{operation.name}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-popover>
    <b-btn size="sm" id="operations">
      <icon name="list"></icon>
    </b-btn>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        popoverShow: false,
      }
    },
    methods: {
      createOperation() {
        this.$router.push({path: `/operation/new`});
        this.popoverShow = false;
      },
    },
    computed: {
      ...mapState('woodware', ['operations'])
    },
    mounted() {
      this.$store.dispatch(`woodware/fetchOperations`);
    }
  }
</script>

<style scoped>
  .operations-groups {
    margin-top: 5px;
  }

  .date-group {
    font-weight: 700;
  }

  .operations-list {
    margin-bottom: 5px;
    padding-left: 25px;
  }

  .operations-type-group {
    margin-left: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/OperationsList.vue